module.exports = __webpack_public_path__ + "assets/img/update_tu.12d49eb7.png";